import {JsonObject, JsonProperty} from 'json2typescript';

@JsonObject('SearchStrategy')
export class SearchStrategy {

    @JsonProperty('token',String,true)
    token = '';

    @JsonProperty('searchStrategy',String,true)
    searchStrategy = '';
}
